import Image from 'next/legacy/image';

import depostRewards from '~/assets/img/marketing/deposit-rewards.svg';
import { PosthogHelper } from '~/helpers/PosthogHelper';
import { baseRoutes } from '~/routes/base';
import { AnalyticsEventNames } from '~/tracking';
import { ReferralCookieHelper } from '~/tracking/referral/ReferralCookieHelper';
import { Box, Flex, Heading, Text } from '~/vinovest-design-system/components';

import { CreateAccountForm } from './CreateAccountForm';
import { CreateAccountTopBar } from './CreateAccountTopBar';

const userSignupContent = (
    <div className={'h-screen min-w-full min-h-screen flex flex-col w-full'}>
        <CreateAccountTopBar />
        <div className={'flex flex-1 justify-center lg:items-center mx-auto'}>
            <div
                className={
                    'flex xs:px-2 px-10 flex-col sm:flex-1 justify-center mx-auto md:mx-8 min-w-full md:min-w-[25rem] self-start md:mt-16 mt-8'
                }
            >
                <Heading level={'h1'} type={'h2'} classnames={'text-center xs:pt-8 pb-0 mb-0'}>
                    Create an account
                </Heading>
                <div className={'mx-auto text-center mt-2 xs:pb-8 lg:pb-12'}>
                    <Text classnames={'text-13'}>
                        Sign up for a FREE account or{' '}
                        <a
                            href={baseRoutes.login.href}
                            onClick={() => PosthogHelper.captureEvent(AnalyticsEventNames.UserSelectLogin)}
                        >
                            <span className={'text-yellow-700 hover:underline'}>Log in</span>
                        </a>
                    </Text>
                </div>
                <CreateAccountForm />
            </div>
        </div>
    </div>
);

const referredUserSignupContent = (
    <>
        <Flex classnames={'min-w-full min-h-screen flex-col'}>
            <Flex>
                <Flex classnames={'flex-col w-full lg:w-1/2'}>
                    <CreateAccountTopBar />

                    <Box classnames={'mx-auto'}>
                        <Heading level={'h1'} type={'h2'} classnames={'text-center xs:pt-8 xs:pb-8 lg:pb-12'}>
                            Create an account
                        </Heading>
                        <div className={'mx-auto text-center mt-6 pb-8 sm:mb-0'}>
                            <Text classnames={'uppercase text-13'}>
                                Sign up for a FREE account or{' '}
                                <a
                                    href={baseRoutes.login.href}
                                    onClick={() => PosthogHelper.captureEvent(AnalyticsEventNames.UserSelectLogin)}
                                >
                                    <span className={'text-yellow-700 hover:underline'}>Log in</span>
                                </a>
                            </Text>
                        </div>
                        <CreateAccountForm />
                    </Box>
                </Flex>
                <Flex classnames={'hidden min-h-screen w-full lg:w-1/2 lg:block sm:mt-8 md:mt-0 bg-brown-100'}>
                    <Box classnames={'max-w-[500px] m-auto text-center'}>
                        <Heading level={'h2'} type={'h3'} classnames={'my-6 normal-case mt-32'}>
                            Your friends loves Vinovest,
                            <br /> and you will too
                        </Heading>
                        <Text classnames={'mt-10 mb-4'}>
                            You’ve been invited to join an exclusive club of wine investors. Now is the time to beat
                            stock market volatility. And while your investment grows, so do the rewards for both you and
                            your friend!
                        </Text>
                        <Text classnames={'mt-6 mb-16'}>Deposit now and claim your rewards!</Text>
                        <Image src={depostRewards} alt={'Deposit now and claim your rewards!'} />
                    </Box>
                </Flex>
            </Flex>
        </Flex>
    </>
);

export const CreateAccountPage = () => {
    const growSurfReferralCode = ReferralCookieHelper.getReferralCookie();
    return <>{growSurfReferralCode ? referredUserSignupContent : userSignupContent}</>;
};
